let daysOfVitalsShownChoices = [
    {name: 'every week', value: 7},
    {name: 'every 2 weeks', value: 14},
    {name: 'every 30 days', value: 30},
    {name: 'every 90 days', value: 90},
    {name: 'every 365 days', value: 365},
    {name: 'all', value: 50000}
];

const state = {
    daysOfVitalsShown : 30
};

const mutations = {
    changeDaysOfVitalsShown(state,data) {
        let validChoice = false;
        validChoice = daysOfVitalsShownChoices.reduce(
            (found,choice) => found || choice.value === data,
            validChoice);
        if(!validChoice)
            throw new Exception("Bad days of shown vitals choice");
        state.daysOfVitalsShown = data;
    }
};

const getters = {
    getDaysofVitalsShownChoices: () => JSON.parse(JSON.stringify(daysOfVitalsShownChoices))
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
};


